<template>
  <div class="navbar-bookmarks flex items-center">
    <vx-tooltip :text="checkModoActualForText" position="bottom" delay=".2s">
      <feather-icon :icon="checkModoActualForIcon" class="cursor-pointer p-2" @click="changeThemeMode()"/>
    </vx-tooltip>
  </div>
</template>

<script>
export default {
  computed: {
    //Para cambiar el modo del tema
    modoActual () {
      return this.$store.state.theme
    },
    checkModoActualForText () {
      return this.modoActual === 'light' ? 'Modo Nocturno' : 'Modo Diurno'
    },
    checkModoActualForIcon () {
      return this.modoActual === 'light' ? 'MoonIcon' : 'SunIcon'
    },
    themeMode: {
      get ()    { return this.$store.state.theme },
      set (val) { this.$store.dispatch('updateTheme', val) }
    },
    textColor () {
      return {'text-white': this.$store.state.mainLayoutType === 'vertical' && this.navbarColor !== (this.$store.state.theme === 'dark' ? '#2B2B2B' : '#fff') }
    }
  },
  methods: {
    changeThemeMode () {
      this.modoActual === 'light' ? this.themeMode = 'dark' : this.themeMode = 'light'
    },
    selected (obj) {
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', false)
      this.showBookmarkPagesDropdown = false
      this.$router.push(obj.pages.url).catch(() => {})
    },
    actionClicked (item) {
      this.$store.dispatch('updateStarredPage', { url: item.url, val: !item.is_bookmarked })
      // this.$refs.bookmarkAutoSuggest.filterData()
    },
    outside () {
      this.showBookmarkPagesDropdown = false
    },
    hnd_search_query_update (query) {
      // Show overlay if any character is entered
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', !!query)
    }
  }
}

</script>
